import { RuleType } from "../interfaces/DTO/insights/PolicyInsightsRuleBased";
import { ProductGroup } from "../interfaces/DTO/insights/insightsOrchestration";

/**
 * ממיר RuleType לטקסט תיאורי בעברית
 */
export function formatRuleType(ruleType: RuleType | null | undefined): string {
  switch (ruleType) {
    case RuleType.EXPIRED_FEES:
      return "הטבת דמי ניהול שפג תוקפה";
    case RuleType.EXPIRED_TEMPORARY_RISK:
      return "תום תוקף ריסק זמני";
    case RuleType.EXPIRED_POWER_OF_ATTORNEY:
      return "ייפוי כח שפג תוקפו";
    case RuleType.LOW_DISABILITY_COVERAGE:
      return "שיעור כיסוי לנכות נמוך מ-75%";
    case RuleType.HIGH_MANAGEMENT_FEE:
      return "דמי ניהול מצבירה ";
    case RuleType.HIGH_MANAGEMENT_FEE_ALL:
      return "דמי ניהול מצבירה  בתיק אישי";
    case RuleType.HIGH_SAVING_FEE_FAMILY:
      return "דמי ניהול מצבירה במשפחה";
    case RuleType.LOW_FUND_RETURN:
      return "תשואת קופה נמוכה ";
    case RuleType.LOW_FUND_RETURN_WITH_LOAN:
      return "תשואת קופה נמוכה בקופה עם הלוואה";
    case RuleType.LOW_DISPERSION:
      return "פיזור תיק נמוך";
    case RuleType.LOW_DISPERSION_FAMILY:
      return "פיזור תיק נמוך במשפחה";
    case RuleType.LOW_STOCK_EXPOSURE:
      return "חשיפה נמוכה למניות בקרנות השתלמות";
    case RuleType.LOW_STOCK_EXPOSURE_FAMILY:
      return "חשיפה נמוכה למניות בקרנות השתלמות - משפחה";
    case RuleType.LOW_STOCK_EXPOSURE_LOAN:
      return "חשיפה נמוכה למניות בפוליסה עם הלוואה";
    case RuleType.LOAN_ENDING_SOON:
      return "הלוואה עומדת להסתיים";
    case RuleType.SURVIVORS_WAIVER_EXPIRING:
      return "ביטול כיסוי שארים עומד לפוג";
    case RuleType.UNNECESSARY_SURVIVORS:
      return "כיסוי שארים מיותר לרווק/ה";
    case RuleType.MISSING_SURVIVORS:
      return "חסר כיסוי שארים לנשוי/ידוע בציבור";
    case RuleType.LONG_TERM_LOW_STOCK_EXP:
      return "נזילות לטווח ארוך במסלול סולידי";
    case RuleType.MISSING_DEPOSIT_WAIVER:
      return "חסר שחרור מהפקדות בביטוח מנהלים";
    case RuleType.LOW_DISABILITY_MANAGERS:
      return "שיעור כיסוי נכות נמוך מ-75% בביטוח מנהלים";
    case RuleType.EDUCATION_GEMEL_SWAP:
      return "קרן השתלמות בחשיפה נמוכה וגמל להשקעה בחשיפה גבוהה";
    case RuleType.CAPITAL_COMPONENT:
      return "רכיב הוני בביטוח מנהלים";
    case RuleType.HIGH_FEE_INACTIVE_MGRS:
      return "דמי ניהול מצבירה גבוהים בביטוח מנהלים לא פעיל";
    case RuleType.HIGH_PENSION_FEE:
      return "דמי ניהול בפנסיה גבוהים מהמדרגות";
    case RuleType.PLUS_COVERAGE_MANAGERS:
      return "ביטוח נוסף בביטוח מנהלים";
    default:
      return "לא ידוע";
  }
}

/**
 * מחזיר צבע לפי סוג תובנה (RuleType)
 */
export const colorRuleType = (ruleType: RuleType): string => {
  switch (ruleType) {
    case RuleType.EXPIRED_FEES:
      return "#6c7038ff"; // בורדו כהה – חמור מאוד
    case RuleType.EXPIRED_TEMPORARY_RISK:
      return "#8f6175ff"; // ורוד-בורדו – חמור
    case RuleType.EXPIRED_POWER_OF_ATTORNEY:
      return "#21336bff"; // ורוד כהה – חמור
    case RuleType.LOW_DISABILITY_COVERAGE:
      return "#866617ff"; // ורוד בינוני – בינוני/גבולי
    case RuleType.HIGH_MANAGEMENT_FEE:
      return "#d53838ff"; // ורוד בהיר – בעיה קלה
    case RuleType.HIGH_MANAGEMENT_FEE_ALL:
      return "#600db3ff"; // ורוד בהיר – בעיה קלה
    case RuleType.HIGH_SAVING_FEE_FAMILY:
      return "#865dc4ff"; // ורוד בהיר – בעיה קלה
    case RuleType.LOW_FUND_RETURN:
      return "#92445eff"; // ורדרד עדין – בעיה מתונה
    case RuleType.LOW_DISPERSION:
      return "#7f8c8d"; // אפור כהה – בעיה מתונה
    case RuleType.LOW_FUND_RETURN_WITH_LOAN:
      return "rgb(160, 66, 94)"; // ורדרד עדין – בעיה מתונה עם הלוואה
    case RuleType.LOW_DISPERSION_FAMILY:
      return "#7f8c8d"; // אפור כהה – בעיה מתונה במשפחה
    case RuleType.LOW_STOCK_EXPOSURE:
      return "#ae64a2ff"; // כחול אפור – בעיה מתונה
    case RuleType.LOW_STOCK_EXPOSURE_FAMILY:
      return "#d24cacff"; // כחול אפור – בעיה מתונה במשפחה
    case RuleType.LOW_STOCK_EXPOSURE_LOAN:
      return "#c0392b"; // אדום כהה – בעיה חמורה (הלוואה + חשיפה נמוכה)
    case RuleType.LOAN_ENDING_SOON:
      return "#f39c12"; // כתום – התראה על סיום הלוואה קרוב
    case RuleType.SURVIVORS_WAIVER_EXPIRING:
      return "#e67e22"; // כתום כהה – התראה על פקיעת ביטול כיסוי שארים
    case RuleType.UNNECESSARY_SURVIVORS:
      return "#f39c12"; // כתום – כיסוי שארים מיותר לרווק/ה
    case RuleType.MISSING_SURVIVORS:
      return "#c0392b"; // אדום כהה – חסר כיסוי שארים לנשוי/ידוע בציבור (בעיה חמורה)
    case RuleType.LONG_TERM_LOW_STOCK_EXP:
      return "#5c6bc0"; // כחול-סגול – נזילות לטווח ארוך במסלול סולידי
    case RuleType.MISSING_DEPOSIT_WAIVER:
      return "#e74c3c"; // אדום בהיר – חסר שחרור מהפקדות בביטוח מנהלים (בעיה חמורה)
    case RuleType.LOW_DISABILITY_MANAGERS:
      return "#c0392b"; // אדום כהה – שיעור כיסוי נכות נמוך בביטוח מנהלים (בעיה חמורה)
    case RuleType.EDUCATION_GEMEL_SWAP:
      return "#7e57c2"; // סגול-כחול – אי-התאמה באסטרטגיית השקעה
    case RuleType.CAPITAL_COMPONENT:
      return "#e67e22"; // כתום – רכיב הוני בביטוח מנהלים
    case RuleType.HIGH_FEE_INACTIVE_MGRS:
      return "#8e44ad"; // סגול – דמי ניהול גבוהים בביטוח מנהלים לא פעיל
    case RuleType.HIGH_PENSION_FEE:
      return "#d35400"; // כתום כהה – דמי ניהול בפנסיה גבוהים מהמדרגות
    case RuleType.PLUS_COVERAGE_MANAGERS:
      return "#e74c3c"; // אדום – ביטוח נוסף בביטוח מנהלים
    default:
      return "#e0e0e0"; // אפור לתקין / לא מסווג
  }
};

// ============================================================================
// קונפיגורציית קטגוריות תובנות
// ============================================================================

/**
 * קטגוריות תובנות
 */
export enum InsightCategory {
  MANAGEMENT = "MANAGEMENT",           // ניהול
  INSURANCE = "INSURANCE",             // ביטוחים
  FEES = "FEES",                       // דמי ניהול
  RETURNS = "RETURNS",                 // תשואות
  PORTFOLIO_BALANCE = "PORTFOLIO_BALANCE" // איזון תיק
}

/**
 * ממפה כל RuleType לקטגוריה שלו
 * רק RuleTypes שמופיעים כאן יוצגו במטריקות
 */
export const RULE_TYPE_TO_CATEGORY: Partial<Record<RuleType, InsightCategory>> = {
  // ניהול
  [RuleType.LOAN_ENDING_SOON]: InsightCategory.MANAGEMENT,
  [RuleType.SURVIVORS_WAIVER_EXPIRING]: InsightCategory.MANAGEMENT,
  [RuleType.EXPIRED_FEES]: InsightCategory.MANAGEMENT,
  [RuleType.EXPIRED_POWER_OF_ATTORNEY]: InsightCategory.MANAGEMENT,

  // ביטוחים
  [RuleType.LOW_DISABILITY_COVERAGE]: InsightCategory.INSURANCE,
  [RuleType.UNNECESSARY_SURVIVORS]: InsightCategory.INSURANCE,
  [RuleType.MISSING_SURVIVORS]: InsightCategory.INSURANCE,
  [RuleType.EXPIRED_TEMPORARY_RISK]: InsightCategory.INSURANCE,
  [RuleType.MISSING_DEPOSIT_WAIVER]: InsightCategory.INSURANCE,
  [RuleType.LOW_DISABILITY_MANAGERS]: InsightCategory.INSURANCE,
  [RuleType.PLUS_COVERAGE_MANAGERS]: InsightCategory.INSURANCE,

  // דמי ניהול
  [RuleType.HIGH_MANAGEMENT_FEE_ALL]: InsightCategory.FEES,
  [RuleType.HIGH_SAVING_FEE_FAMILY]: InsightCategory.FEES,
  [RuleType.HIGH_FEE_INACTIVE_MGRS]: InsightCategory.FEES,
  [RuleType.HIGH_PENSION_FEE]: InsightCategory.FEES,
  [RuleType.CAPITAL_COMPONENT]: InsightCategory.FEES,

  // תשואות
  [RuleType.LOW_FUND_RETURN_WITH_LOAN]: InsightCategory.RETURNS,
  [RuleType.LOW_FUND_RETURN]: InsightCategory.RETURNS,

  // איזון תיק
  [RuleType.LOW_DISPERSION]: InsightCategory.PORTFOLIO_BALANCE,
  [RuleType.LOW_DISPERSION_FAMILY]: InsightCategory.PORTFOLIO_BALANCE,
  [RuleType.LOW_STOCK_EXPOSURE]: InsightCategory.PORTFOLIO_BALANCE,
  [RuleType.LOW_STOCK_EXPOSURE_FAMILY]: InsightCategory.PORTFOLIO_BALANCE,
  [RuleType.LOW_STOCK_EXPOSURE_LOAN]: InsightCategory.PORTFOLIO_BALANCE,
  [RuleType.LONG_TERM_LOW_STOCK_EXP]: InsightCategory.PORTFOLIO_BALANCE,
  [RuleType.EDUCATION_GEMEL_SWAP]: InsightCategory.PORTFOLIO_BALANCE,
};

/**
 * שמות הקטגוריות בעברית
 */
export const CATEGORY_NAMES: Record<InsightCategory, string> = {
  [InsightCategory.MANAGEMENT]: "ניהול",
  [InsightCategory.INSURANCE]: "ביטוחים",
  [InsightCategory.FEES]: "דמי ניהול",
  [InsightCategory.RETURNS]: "תשואות",
  [InsightCategory.PORTFOLIO_BALANCE]: "איזון תיק",
};

/**
 * צבעים לכל קטגוריה
 */
export const CATEGORY_COLORS: Record<InsightCategory, string> = {
  [InsightCategory.MANAGEMENT]: "#f39c12",        // כתום - ניהול
  [InsightCategory.INSURANCE]: "#c0392b",         // אדום - ביטוחים
  [InsightCategory.FEES]: "#600db3ff",            // סגול - דמי ניהול
  [InsightCategory.RETURNS]: "#92445eff",         // ורדרד - תשואות
  [InsightCategory.PORTFOLIO_BALANCE]: "#5c6bc0", // כחול-סגול - איזון תיק
};

/**
 * סדר הצגת הקטגוריות
 */
export const CATEGORY_ORDER: InsightCategory[] = [
  InsightCategory.MANAGEMENT,
  InsightCategory.INSURANCE,
  InsightCategory.FEES,
  InsightCategory.RETURNS,
  InsightCategory.PORTFOLIO_BALANCE,
];

/**
 * פונקציה לקבלת קטגוריה לפי RuleType
 * מחזיר undefined אם ה-RuleType לא קיים במיפוי (כמו HIGH_MANAGEMENT_FEE)
 */
export function getCategoryByRuleType(ruleType: RuleType): InsightCategory | undefined {
  return RULE_TYPE_TO_CATEGORY[ruleType];
}

/**
 * פונקציה לקבלת שם קטגוריה בעברית
 */
export function getCategoryName(category: InsightCategory): string {
  return CATEGORY_NAMES[category];
}

/**
 * פונקציה לקבלת צבע קטגוריה
 */
export function getCategoryColor(category: InsightCategory): string {
  return CATEGORY_COLORS[category];
}

/**
 * פונקציה לקבלת כל ה-RuleTypes של קטגוריה מסוימת
 */
export function getRuleTypesByCategory(category: InsightCategory): RuleType[] {
  return Object.entries(RULE_TYPE_TO_CATEGORY)
    .filter(([_, cat]) => cat === category)
    .map(([ruleType]) => ruleType as RuleType);
}

/**
 * ממיר ProductGroup לשם קבוצת המוצרים בעברית
 */
export function formatProductGroup(productGroup: ProductGroup): string {
  switch (productGroup) {
    case ProductGroup.PROVIDENT:
      return "גמל והשתלמות";
    case ProductGroup.PURE_SAVINGS:
      return "פוליסות חיסכון";
    case ProductGroup.PENSION:
      return "פנסיה";
    default:
      return "";
  }
}
